import { RootState } from 'reducers'

import { AppDispatch as AppDispatchType } from 'store'

import { NotificationList } from 'types/notification'

/**
 * Criando types para elementos genericos.
 */

export type StringList = string[]

export type RootReducerState = RootState

export type AppDispatch = AppDispatchType

export type GenericList = NotificationList | StringList

export type GenericObject = {}

export type GenericValue = unknown

/**
 * Tipo para paginação.
 */
export type PageType = {
    size: number | unknown
    totalElements: number | unknown
    totalPages: number | unknown
    number: number | unknown
}

/**
 * Interface para paginação.
 */
export interface Page extends PageType {
    size: number | unknown
    totalElements: number | unknown
    totalPages: number | unknown
    number: number | unknown
}

/**
 * Objeto inicializador padrão
 */
export const PageTypeInitiator:Page = {
    size: null,
    totalElements: null,
    totalPages: null,
    number: null
}

/**
 * Tipo para paginação para solicitar busca por termo e troca de pagina.
 */
export type PaginationType = {
    page: number
    param: string | unknown
};

/**
 * Interface para paginação por GET.
 */
 export interface Pagination extends PaginationType {
    page: number
    param: string | unknown
}

/**
 * Objeto inicializador padrão
 */
export const PaginationTypeInitiator:Pagination = {
    page: 0,
    param: undefined
}
/**
 * Propriedades para exibir mensagens usando o component <ActionStatus/>
 */
interface IMessage {
    text?: string
    status?: number
    visible: boolean
}
/**
 * Tipo para exibir mensagens usando o component <ActionStatus/>
 */
export type Message = IMessage
/**
 * Objeto inicializador do tipo Message
 */
export const MessageTypeInitiator:Message = {
    visible: false,
}

interface ICount {
    count: string
}

interface IStatsCount {
    stats: ICount
}
/**
 * Usado como objeto pardar para retorno de contagens no servicenow
 * <table>?sysparm_count=true
 */
export type StatsCount = IStatsCount

export type Count = ICount

/**
 * Objeto do Axios Mock Adapter
 */
interface IMock {
    url: any
    method: string
    data: any
}
/**
 * Tipo do Axios Mock Adapter
 */
export type Mock = IMock

/**
 * Redux Global
 */

/**
 * Interface para redux action 
 */
export interface IGlobalAction {
    type: string
    payload: string
}
/**
 * Interface para objeto reducer
 */
export interface IGlobalReducer {
    data: any
    loading: boolean
    error: boolean
}

export type GlobalAction = IGlobalAction
/**
 * Tipo para reducer
 */
export type GlobalReducer = IGlobalReducer

/**
 * Objeto padrão
 */
export const GlobalReducerTypeInitiator:IGlobalReducer = {
    data: null,
    loading : false,
    error: false,
}